import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

export interface EmptyContentProps {
  label: string;
}

export default function EmptyContent({ label }: EmptyContentProps) {
  return (
    <Box
      justifyContent="center"
      alignItems="center"
      minHeight={150}
      display="flex"
      width="100%"
    >
      <Typography>{label}</Typography>
    </Box>
  );
}
